import axios from 'axios'
import fetch from '@/utils/fetch'

/**
 * 七牛token
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getToken() {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/get_token',
    method: 'post',
    data: {}
  })
}

/**
 * 更新session心跳接口
 *
 * @export
 * @param {any} data
 * @returns
 */
export function heartbeat(data = {}) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/heart',
    method: 'post',
    data
  })
}

/**
 * 七牛图片格式转换
 *
 * @export
 * @param {any} data
 * @returns
 */
export function imageConvert(url, format) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/image/convert',
    method: 'post',
    data: { url, format }
  })
}

/**
 * 图片抓取，格式jpg
 *
 * @export
 * @param {any} data
 * @returns
 */
export function fetchImage(url) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/image/fetch',
    method: 'post',
    data: { url }
  })
}

/**
 * 获取手机区号
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getPhoneCode(data = {}) {
  return fetch({
    url: '/api_user/service/w/account/get_area_code',
    method: 'get',
    data
  })
}

/**
 * 获取图片验证码
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getImageCode(sessionId) {
  return `${
    process.env.VUE_APP_BASE_API
  }/api_user/service/w/nwr/account/verifycode/image?sessionId=${sessionId}`
}

/**
 * 发送验证码
 *
 * @export
 * @param {any} data
 * @returns
 */
export function sendCode(data = {}) {
  return fetch({
    url: '/api_user/service/w/account/verifycode/send',
    method: 'post',
    data
  })
}

/**
 * 获取token用户
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getTokenUser(data = {}) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/user/get_vo_simple_self',
    method: 'post',
    data
  })
}
/**
 * 获取省市区
 */
export function getAddress() {
  return axios
    .post('https://img.zai-art.com/B5365F50C53E8839CB8A585C2BFC71E3.json')
    .then(response => {
      return response.data
    })
}
